import React from 'react';
import { Hero } from './components/Hero';
import { Identification } from './components/Identification';
import { Solution } from './components/Solution';
import { Product } from './components/Product';
import { Bonuses } from './components/Bonuses';
import { ValueStack } from './components/ValueStack';
import { Benefits } from './components/Benefits';
import { Objections } from './components/Objections';
import { Testimonials } from './components/Testimonials';
import { Urgency } from './components/Urgency';
import { Closing } from './components/Closing';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-brand-white font-sans text-brand-text selection:bg-brand-gold/30" data-id="element-0">
      <Hero data-id="element-1" />
      <Identification data-id="element-2" />
      <Solution data-id="element-3" />
      <Product data-id="element-4" />
      <Bonuses data-id="element-5" />
      <ValueStack data-id="element-6" />
      <Benefits data-id="element-7" />
      <Objections data-id="element-8" />
      <Testimonials data-id="element-9" />
      <Urgency data-id="element-10" />
      <Closing data-id="element-11" />
      <Footer data-id="element-12" />
    </div>;
}